import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import {
  getGeneralProjects,
  getSeasonalProjects,
} from "../../../apis/actions/projects.actions";
import ComposedCard from "../../../biblio/Cards/ComposedCard";

const OtherProjectsCard = () => {
  const dispatch = useDispatch<AppDispatch>();

  const seasonalProjects = useSelector(
    (state: RootState) => state?.projects?.seasonalProjects
  );

  const generalProject = useSelector(
    (state: RootState) => state?.projects?.projects
  );

  const detailProject = useSelector(
    (state: RootState) => state?.projects?.detailsProject?.project
  );

  const [filteredProjects, setFilteredProjects] =
    useState<any[]>(seasonalProjects);

  useEffect(() => {
    dispatch(getSeasonalProjects());
    dispatch(getGeneralProjects());
  }, [dispatch]);

  useEffect(() => {
    setFilteredProjects(
      detailProject?.type === "general"
        ? generalProject
            .filter((project: any) => project.id !== detailProject?.id)
            .sort((a: any, b: any) => {
              return a.sequence - b.sequence;
            })
        : seasonalProjects
            .filter((project: any) => project.id !== detailProject?.id)
            .sort((a: any, b: any) => {
              return a.sequence - b.sequence;
            })
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seasonalProjects, detailProject]);

  return (
    <div className="takaful--card-other-container">
      <div className="takaful--card-other-title">
        <span>مشاريع اخرى تحتاج دعمك</span>
      </div>

      <div className="takaful--cases-section">
        <div className="takaful--cases" style={{ marginTop: "10rem" }}>
          {filteredProjects.length > 0 &&
            filteredProjects
              .slice(0, 4)
              .map((project: any, index: number) => (
                <ComposedCard
                  key={index}
                  donation_type_ids={project.donation_type_ids}
                  type="المشاريع"
                  project={project}
                  cardClass={"card-1"}
                />
              ))}
        </div>
      </div>
    </div>
  );
};

export default OtherProjectsCard;
